import { WITHDRAWAL_AGGREGATOR_ID } from './withdrawal';

export const MAX_WITHDRAWAL_DISTRIBUTION_PERCENT = 100;
export const MIN_WITHDRAWAL_DISTRIBUTION_PERCENT = 0;

export enum WITHDRAWAL_PAYMENT_SYSTEM_ID {
  RU_CARD = 1,
  UA_CARD = 2,
  WEB_MONEY = 3,
  QIWI = 4,
  G_CASH = 5,
  SMART_PAY_MAYA = 6,
  COINS_PH_WALLET = 7,
  USDT = 8,
  CAPITALIST_USDT = 9,
}

export enum WITHDRAWAL_PAYMENT_SYSTEM_STATE {
  ENABLED = 'enabled',
  DISABLED = 'disabled',
}

export enum WITHDRAWALS_AGGREGATOR_STATE {
  ENABLED = 'enabled',
  DISABLED = 'disabled',
}

export type WithdrawalsDistributionId = WITHDRAWAL_AGGREGATOR_ID;

export type AggregatorPaymentSystem = {
  paymentSystemState: WITHDRAWAL_PAYMENT_SYSTEM_STATE;
  distributionPercent: number;
};

export type AggregatorPaymentSystems = Record<
  WITHDRAWAL_PAYMENT_SYSTEM_ID,
  AggregatorPaymentSystem
>;

export type AggregatorPaymentSystemBalance = {
  balance: null | {
    total: number;
    balanceCurrencyCode: string;
    lastTransactionTime: Date;
  };
};

export type WithdrawalsDistributionSettingsItem = {
  aggregatorState: WITHDRAWALS_AGGREGATOR_STATE;
  paymentSystems: AggregatorPaymentSystems;
};

export type WithdrawalsDistributionBalanceItem = {
  paymentSystems: Record<
    WITHDRAWAL_PAYMENT_SYSTEM_ID,
    AggregatorPaymentSystemBalance
  >;
};

export type WithdrawalsDistributionSettingsItems = Record<
  WithdrawalsDistributionId,
  WithdrawalsDistributionSettingsItem
>;

export type WithdrawalsDistributionBalanceItems = Record<
  WithdrawalsDistributionId,
  WithdrawalsDistributionBalanceItem
>;
